/**
 * Textes de la page /v50 (OpenBroV50), FR et EN.
 * Charpente et ton façon university.com (pills en majuscules, titres courts, un mot mis en avant),
 * texte original. Aucun chiffre qui ne vienne de l'offre réelle (config/offer.js, espace membre, lib/callSlots).
 * `**mot**` = mot mis en avant (dégradé sable dans les titres, blanc appuyé dans le corps).
 */

const COPY = {
  fr: {
    lang: 'FR',
    switchLabel: 'Switch to English',
    login: 'Connexion',
    headerCta: 'Rejoindre',
    headerSlot: (time) => `Réserver ${time}`,

    bandKicker: 'Ton créneau',
    bandLeft: (left) => `Réservable encore ${left}`,

    filmPlay: 'Lancer la vidéo',
    filmProgress: 'Progression',

    heroPill: 'Mentorat privé',
    heroTitle: 'Un mentor.\nUn plan.\n**Dès aujourd’hui.**',
    heroLead: 'Chaque mois, **Gaut t’appelle.** Vous réglez ce qui te bloque, et tu repars avec **ton plan des 30 prochains jours.**',
    heroCta: 'Rejoindre OpenBro',
    takeSlot: (label) => `Réserver ${label}`,
    stats: (lessons) => [['6', 'Campus'], [String(lessons), 'Leçons'], ['1', 'Appel privé par mois']],
    slotsLabel: 'Choisis ton créneau',
    slotsBody: 'Gaut t’appelle au numéro indiqué au paiement. Le créneau est bloqué dès que c’est réglé.',
    payNote: (price) => `${price}/mois · Sans engagement · Résiliable à tout moment`,
    leftFmt: { day: 'j', hour: 'h', min: 'min', sec: 's' },

    actionPill: 'Passe à l’action',
    actionTitle: 'L’école ne t’a pas appris **à avancer.**',
    action: [
      'On t’a appris à réciter. **Pas à te lever tôt, à manger proprement ou à lancer un projet.**',
      'Les vidéos gratuites ne manquent pas. Ce qui manque, c’est **quelqu’un qui te dit quoi faire ce mois-ci**, et qui vérifie le mois suivant.',
      '**OpenBro, c’est ça** : un appel, un plan, et un cadre pour le tenir.',
    ],

    campusPill: 'Accès à 6 campus',
    campusTitle: 'Ce que tu vas **apprendre**',
    campusBody: 'Des leçons concrètes, de zéro à l’exécution. **Tu commences par ce qui compte pour toi.**',
    campus: {
      musculation: ['Musculation & Discipline', 'Technique, programmation, progression. De zéro à intermédiaire.'],
      nutrition: ['Nutrition & Performance', 'Quoi manger, quand, et un système simple à tenir.'],
      reseaux: ['E-commerce & Réseaux sociaux', 'Lancer ta marque, vendre en ligne, faire grandir un compte.'],
      montage: ['Montage vidéo', 'Le rythme qui retient et les accroches qui arrêtent le scroll.'],
      ia: ['IA & Automatisation', 'Faire travailler l’IA pour toi, et vendre des services IA.'],
      filming: ['Tournage & Filming', 'Cadrer, éclairer, tourner proprement avec ce que tu as.'],
    },
    lessons: (n) => `${n} leçons`,

    platformPill: 'L’espace membre',
    platformTitle: 'Tout au même endroit. **Ouvert dès le paiement.**',
    platform: [
      '**Formations, plan du mois, suivi de tes habitudes, Monk Mode et communauté.** Sur téléphone et sur ordinateur.',
      'Tu actives ton compte avec ton email, tu te connectes avec un code, **et tu commences.**',
    ],
    vaultLock: 'Réservé aux membres',

    storiesPill: 'Ils ont commencé',
    storiesTitle: 'Un appel. **Puis un plan.**',
    stories: { adam: ['La salle', '100 kg au squat'], ines: ['L’assiette', 'Meal prep le dimanche'], theo: ['Le business', 'Site en ligne en 30 jours'], lucas: ['La vie', 'Debout à 6 h 30'] },
    storiesNote: 'Mises en situation. Voir la FAQ.',

    features: [
      { pill: 'La discipline', title: 'Avancer est **une compétence.**', body: 'Elle s’apprend comme le reste : **un objectif, des étapes, et quelqu’un qui te les redemande.** Ton plan couvre ton assiette, ton entraînement et ton business.' },
      { pill: 'La communauté', title: 'Un groupe **privé.**', body: 'Des membres qui partagent **leurs séances, leurs repas et leurs projets.** Tu y trouves un partenaire de salle, ou un associé.' },
      { pill: 'Le mentor', title: 'Gaut, **au téléphone.**', body: 'Pas un cours enregistré. **Une conversation, une fois par mois, sur ta situation.** Ce qui marche, ce qui te freine, et ce que tu fais dès demain.' },
    ],

    pathsPill: 'Choisis ton chemin',
    pathsTitle: 'Deux chemins **devant toi.**',
    offTitle: 'Continuer seul',
    offSub: 'Le même mois, encore une fois',
    off: [
      'Des heures de vidéos, rien ne bouge',
      'Des conseils qui se contredisent',
      'Personne pour te répondre',
      'Tu t’entraînes sans plan',
      'Tu recommences lundi',
    ],
    offCta: 'Rester comme je suis',
    offHref: 'https://www.netflix.com',
    onSub: 'Commencer aujourd’hui',
    period: '/mois',
    on: [
      'Un appel privé avec Gaut chaque mois',
      'Ton plan 30 jours : alimentation, entraînement, business',
      'Les 6 campus et leurs leçons',
      'La communauté privée',
      'Le suivi de tes habitudes et le Monk Mode',
      'Sans engagement, résiliable à tout moment',
    ],
    secure: 'Paiement sécurisé par Stripe',
    crypto: 'Payer en USDC (Solana)',

    winsPill: 'Dans le groupe',
    winsTitle: 'Les bros **avancent.**',

    lastPill: 'Créneaux disponibles',
    lastTitle: 'Ton créneau **t’attend.**',
    lastBody: 'Dans 30 jours, tu peux avoir **un plan tenu**, ou le même mois derrière toi.',
    lastLeft: ({ label, left }) => `**${label}** · Réservable encore **${left}**`,

    faqPill: 'FAQ',
    faqTitle: 'Questions **fréquentes**',
    faq: [
      ['Comment se passe l’appel ?', 'Tu choisis ton créneau **avant de payer**. Gaut t’appelle au numéro indiqué au paiement. Vous faites le point sur ta situation et **tu repars avec tes priorités du mois.**'],
      ['Pourquoi le créneau a une limite ?', 'Un créneau se réserve **jusqu’à 1 h 30 avant son heure.** Ensuite il disparaît et d’autres créneaux sont proposés.'],
      ['Que se passe-t-il juste après le paiement ?', 'Tu actives ton compte avec ton prénom et ton email. Tu te connectes avec un code reçu par email, et **tu as accès à tout** : campus, suivi, communauté.'],
      ['Je suis débutant, c’est un problème ?', 'Non. **Les leçons partent de zéro**, et l’appel part de **ta situation**, pas d’un programme standard.'],
      ['Combien ça coûte ?', '**49 € par mois**, prélevés par Stripe. Tu peux aussi payer en USDC sur Solana.'],
      ['Je peux arrêter quand je veux ?', 'Oui. **L’abonnement est sans engagement**, tu le résilies quand tu veux. Les mois déjà payés ne sont pas remboursés.'],
      ['Les résultats sont-ils garantis ?', 'Oui. **Tu as un plan, un regard extérieur et un cadre.** Le travail, c’est toi qui le fais.'],
      ['Les vidéos et les messages, c’est qui ?', 'Les vidéos de la section « Ils ont commencé » sont **des mises en situation**, pas des membres filmés. Les campus et les écrans de l’espace membre **viennent du vrai produit.**'],
    ],
    faqMore: 'Une autre question ? Écris à',

    toasts: ({ label, left, price }) => [
      ['Ton appel', label, 'Encore libre'],
      left && ['Réservation', `Réservable encore ${left}`, 'Ensuite, le créneau passe'],
      ['OpenBro', `${price}/mois`, 'Sans engagement'],
      ['Accès immédiat', '6 campus, dès le paiement', 'Sur mobile et ordinateur'],
    ].filter(Boolean),
    peekMine: 'Ton créneau',
    peekOther: 'Créneau disponible',
    peekFoot: 'Clique pour le réserver',
    close: 'Fermer',

    nudgeKicker: 'Ton créneau est prêt',
    nudgeLeft: (left) => `Réservable encore ${left}. Ensuite, il passe.`,
    nudgeLater: 'Plus tard',

    barSlot: 'Ton créneau',
    barLeft: (left) => `Réservable encore ${left}`,
    barTake: 'Je le prends',

    footerTag: 'by Gaut Bonac',
    terms: 'Conditions générales',
    privacy: 'Confidentialité',
    rights: 'Tous droits réservés.',
    title: 'OpenBro · Le mentorat privé de Gaut Bonac',
  },
  en: {
    lang: 'EN',
    switchLabel: 'Passer en français',
    login: 'Log in',
    headerCta: 'Join',
    headerSlot: (time) => `Book ${time}`,

    bandKicker: 'Your slot',
    bandLeft: (left) => `Bookable for ${left} more`,

    filmPlay: 'Play the video',
    filmProgress: 'Progress',

    heroPill: 'Private mentorship',
    heroTitle: 'One mentor.\nOne plan.\n**Starting today.**',
    heroLead: 'Every month, **Gaut calls you.** You clear what’s blocking you, and you leave with **your plan for the next 30 days.**',
    heroCta: 'Join OpenBro',
    takeSlot: (label) => `Book ${label}`,
    stats: (lessons) => [['6', 'Campuses'], [String(lessons), 'Lessons'], ['1', 'Private call a month']],
    slotsLabel: 'Pick your slot',
    slotsBody: 'Gaut calls you on the number you give at checkout. The slot is yours as soon as you pay.',
    payNote: (price) => `${price}/month · No commitment · Cancel anytime`,
    leftFmt: { day: 'd', hour: 'h', min: 'min', sec: 's' },

    actionPill: 'Take action',
    actionTitle: 'School never taught you **how to move forward.**',
    action: [
      'You were taught to memorize. **Not to get up early, eat right or launch a project.**',
      'There’s no shortage of free videos. What’s missing is **someone who tells you what to do this month**, and checks on it the next.',
      '**That’s OpenBro**: one call, one plan, and a structure to stick to it.',
    ],

    campusPill: 'Access 6 campuses',
    campusTitle: 'What you’ll **learn**',
    campusBody: 'Practical lessons, from zero to execution. **Start with what matters to you.**',
    campus: {
      musculation: ['Strength & Discipline', 'Technique, programming, progression. Beginner to intermediate.'],
      nutrition: ['Nutrition & Performance', 'What to eat, when, and a simple system you can keep.'],
      reseaux: ['E-commerce & Social media', 'Launch your brand, sell online, grow an account.'],
      montage: ['Video editing', 'Pacing that holds attention and hooks that stop the scroll.'],
      ia: ['AI & Automation', 'Put AI to work for you, and sell AI services.'],
      filming: ['Filming', 'Frame, light and shoot cleanly with what you have.'],
    },
    lessons: (n) => `${n} lessons`,

    platformPill: 'The member area',
    platformTitle: 'Everything in one place. **Open the moment you pay.**',
    platform: [
      '**Programs, your monthly plan, habit tracking, Monk Mode and the community.** On phone and computer.',
      'Activate your account with your email, log in with a code, **and start.**',
    ],
    vaultLock: 'Members only',

    storiesPill: 'They started',
    storiesTitle: 'One call. **Then a plan.**',
    stories: { adam: ['The gym', '100 kg squat'], ines: ['The plate', 'Meal prep every Sunday'], theo: ['Business', 'Site live in 30 days'], lucas: ['Daily life', 'Up at 6:30'] },
    storiesNote: 'Dramatizations. See the FAQ.',

    features: [
      { pill: 'Discipline', title: 'Moving forward is **a skill.**', body: 'You learn it like anything else: **a goal, steps, and someone who asks you about them.** Your plan covers your plate, your training and your business.' },
      { pill: 'Community', title: 'A **private** group.', body: 'Members sharing **their workouts, their meals and their projects.** You find a gym partner there, or a co-founder.' },
      { pill: 'The mentor', title: 'Gaut, **on the phone.**', body: 'Not a recorded class. **A conversation, once a month, about your situation.** What works, what holds you back, and what you do starting tomorrow.' },
    ],

    pathsPill: 'Choose your path',
    pathsTitle: 'Two paths **in front of you.**',
    offTitle: 'Keep going alone',
    offSub: 'The same month, once again',
    off: [
      'Hours of videos, nothing moves',
      'Advice that contradicts itself',
      'Nobody to answer you',
      'You train without a plan',
      'You start again on Monday',
    ],
    offCta: 'Stay as I am',
    offHref: 'https://www.netflix.com',
    onSub: 'Start today',
    period: '/month',
    on: [
      'A private call with Gaut every month',
      'Your 30-day plan: food, training, business',
      'All 6 campuses and their lessons',
      'The private community',
      'Habit tracking and Monk Mode',
      'No commitment, cancel anytime',
    ],
    secure: 'Secure payment by Stripe',
    crypto: 'Pay in USDC (Solana)',

    winsPill: 'In the group',
    winsTitle: 'The bros **are moving.**',

    lastPill: 'Open slots',
    lastTitle: 'Your slot **is waiting.**',
    lastBody: 'In 30 days, you can have **a plan you kept**, or the same month behind you.',
    lastLeft: ({ label, left }) => `**${label}** · Bookable for **${left}** more`,

    faqPill: 'FAQ',
    faqTitle: 'Common **questions**',
    faq: [
      ['How does the call work?', 'You pick your slot **before paying**. Gaut calls you on the number you give at checkout. You go over your situation and **you leave with your priorities for the month.**'],
      ['Why does the slot have a deadline?', 'A slot can be booked **until 1h30 before its time.** After that it’s gone and other slots are offered.'],
      ['What happens right after I pay?', 'You activate your account with your first name and email. You log in with a code sent by email, and **you get access to everything**: campuses, tracking, community.'],
      ['I’m a beginner. Is that a problem?', 'No. **The lessons start from zero**, and the call starts from **your situation**, not a standard plan.'],
      ['How much is it?', '**€49 a month**, charged by Stripe. You can also pay in USDC on Solana.'],
      ['Can I stop whenever I want?', 'Yes. **No commitment**, cancel whenever you want. Months already paid are not refunded.'],
      ['Are results guaranteed?', 'Yes. **You get a plan, an outside view and structure.** The work is yours to do.'],
      ['Who are the people in the videos and messages?', 'The videos in “They started” are **dramatizations**, not filmed members. The campuses and member-area screens **come from the real product.**'],
    ],
    faqMore: 'Another question? Email',

    toasts: ({ label, left, price }) => [
      ['Your call', label, 'Still open'],
      left && ['Booking', `Bookable for ${left} more`, 'Then the slot passes'],
      ['OpenBro', `${price}/month`, 'No commitment'],
      ['Instant access', '6 campuses, the moment you pay', 'On phone and computer'],
    ].filter(Boolean),
    peekMine: 'Your slot',
    peekOther: 'Open slot',
    peekFoot: 'Click to book it',
    close: 'Close',

    nudgeKicker: 'Your slot is ready',
    nudgeLeft: (left) => `Bookable for ${left} more. Then it passes.`,
    nudgeLater: 'Later',

    barSlot: 'Your slot',
    barLeft: (left) => `Bookable for ${left} more`,
    barTake: 'Take it',

    footerTag: 'by Gaut Bonac',
    terms: 'Terms',
    privacy: 'Privacy',
    rights: 'All rights reserved.',
    title: 'OpenBro · Private mentorship with Gaut Bonac',
  },
};

export default COPY;
